<template>
    <header>
        <nav>
            <h1>
                <router-link to="/">THE PLANETS</router-link>
            </h1>
            <div v-if="isSmallScreen" class="menuBtn" @click="toggleDropdownMenu">
                <div class="menuBtnLine" v-for="num in 3" :key="num"></div>
            </div>
            <ul v-else>
                <li v-for="planet in planetsList" :key="planet">
                    <router-link :to="{ params: { planetId: planet } }">{{ planet.toUpperCase() }}</router-link>
                </li>
            </ul>
        </nav>
    </header>
    <hr>
    <dropdown-menu v-if="isSmallScreen && isDropdownMenuVisisble"></dropdown-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import DropdownMenu from './DropdownMenu.vue';
export default {
    components: {
        DropdownMenu
    },
    provide () {
        return {
            closeDropdownMenu: this.toggleDropdownMenu
        };
    },
    data () {
        return {
            isDropdownMenuVisisble: false
        };
    },
    computed: {
        ...mapGetters(['isSmallScreen', 'planetsList', 'screenWidth'])
    },

    methods: {
        toggleDropdownMenu() {
            this.isDropdownMenuVisisble = !this.isDropdownMenuVisisble;
        }
    }
}
</script>

<style scoped>
    header {
        height: 6rem;
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
    }

    header nav {
        height: 100%;
        width: 100%;
        padding: 0 5%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    header h1 {
        font-size: 2.5rem;
        letter-spacing: -1.5px;
        line-height: 52px;        
    }

    header ul {
        height: 100%;
        margin: 0;
        padding: 0;
        list-style: none;
        display: grid;
        grid-auto-flow: column;
        grid-auto-columns: 1fr;
        justify-items: center;
    }

    li {
        height: 100%;
        font-family: "Spartan", sans-serif;
        font-size: 0.75rem;
        font-weight: bold;
        letter-spacing: 2.6px;
        line-height: 25px;        
        margin: 0 0.5rem;
    }

    a {        
        text-decoration: none;
    }

    h1 a {
        color: #fff;
    }

    li a {
        height: 100%;
        display: flex;
        align-items: center;
        color: #838391;
        border-top: solid 4px transparent;
    }

    li a:active,
    li a.router-link-active {
        color: #fff;
        border-top: solid 4px #fff;
    }

    hr {
        height: 1px;
        margin: 0;
        border: none;
        border-top: solid 1px #838391;
    }

    .menuBtn {
        cursor: pointer;
        height: 17px;
        min-width: 24px;
        width: 24px;  
    }

    .menuBtnLine {
        height: 3px;
        background-color: #fff;
        margin: 2px 0;
    }

   
</style>